


































































































































































































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation, State } from "vuex-class";

import { validationMixin } from "vuelidate";
import { maxValue, minValue, required } from "vuelidate/lib/validators";

import { falconComplaintFaultEntityFilter } from "@/filters/falcon/falcon-complaint-fault-entity.filter";
import { capitalizeFilter } from "@/filters/capitalize.filter";

import { minDateValidator } from "@/validators/min-date.validator";
import { maxCurrentDateValidator } from "@/validators/max-current-date.validator";

import { DoCreateComplaintSecondStepFormData } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-second-step-form-data";

import { FalconComplaintFaultEntity } from "@/enums/falcon/complaints/falcon-complaint-fault-entity.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint creation second step form - vehicle data
 */
@Component<ComplaintCreationSecondStepForm>({
  mixins: [validationMixin],
  filters: {
    ...falconComplaintFaultEntityFilter,
    ...capitalizeFilter
  },
  validations() {
    return {
      form: {
        counterStateInstall: {
          required,
          maxValue: maxValue(this.form.counterStateUninstall as number)
        },
        installDate: {
          required,
          maxDate: maxCurrentDateValidator(this.form.uninstallDate as string)
        },
        counterStateUninstall: {
          required,
          minValue: minValue(this.form.counterStateInstall as number)
        },
        uninstallDate: {
          required,
          minDate: minDateValidator(this.form.installDate as string),
          maxDate: maxCurrentDateValidator()
        }
      }
    };
  }
})
export default class ComplaintCreationSecondStepForm extends Vue {
  @State(state => state.falconComplaints.complaintFormData.vehicle)
  private vehicleFormData!: DoCreateComplaintSecondStepFormData;
  @Mutation("falconComplaints/secondStepFormUpdated")
  private secondStepFormUpdated!: (
    formData: DoCreateComplaintSecondStepFormData
  ) => void;

  falconComplaintEntityEnum = FalconComplaintFaultEntity;
  i18nMessageKeyEnum = I18nMessageKey;

  form: DoCreateComplaintSecondStepFormData = {
    registerNumber: undefined,
    engineNumber: undefined,
    vinNumber: undefined,
    brandVehicle: undefined,
    productionYear: undefined,
    engineCapacity: undefined,
    powerValue: undefined,
    powerUnit: undefined,
    workshopInstallName: undefined,
    workshopInstallAddress: undefined,
    installedBy: undefined,
    counterStateInstall: undefined,
    installDate: undefined,
    workshopUninstallName: undefined,
    workshopUninstallAddress: undefined,
    uninstalledBy: undefined,
    counterStateUninstall: undefined,
    uninstallDate: undefined
  };

  created(): void {
    this.form = { ...this.vehicleFormData };
  }

  formDataChanged(): void {
    this.secondStepFormUpdated(this.form);
  }
}
